import axios from "axios"

export interface StatsResponse {
  meetings: number
  minutes: number
  users: number
}

const httpClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
})

async function getMeetings(): Promise<number> {
  const response = await httpClient.get<{ total: number }>("/stats/meetings")
  return response.data.total
}

async function getMinutes(): Promise<number> {
  const response = await httpClient.get<{ total: number }>("/stats/minutes")
  return response.data.total
}

async function getUsers(): Promise<number> {
  const response = await httpClient.get<{ total: number }>("/stats/users")
  return response.data.total
}

async function getAllStats(): Promise<StatsResponse> {
  const [meetings, minutes, users] = await Promise.all([
    getMeetings(),
    getMinutes(),
    getUsers(),
  ])
  return { meetings, minutes, users }
}

export const statsApi = {
  getMeetings,
  getMinutes,
  getUsers,
  getAllStats,
}
